module.exports = __webpack_public_path__ + "img/usuario-econopro-galpao.5135b15f.png";